import IMWarehouse from './IMWarehouse';

export default IMWarehouse;
